import axios from "axios";

/**
 * Resolve the backend base URL.
 *
 * Production note: the apex domain (jmrgloballogistics.com) issues a 308
 * redirect to www.jmrgloballogistics.com. Browsers do not preserve the body /
 * CORS on a cross-origin 308 for POST/multipart requests, so form submissions
 * fail. To avoid the redirect entirely we normalize the apex host to the www
 * host so the request lands on its canonical origin directly.
 */
function resolveBackendUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL || "";
  try {
    const u = new URL(raw);
    if (u.hostname === "jmrgloballogistics.com") {
      u.hostname = "www.jmrgloballogistics.com";
      return u.origin;
    }
    return raw.replace(/\/+$/, "");
  } catch {
    return raw.replace(/\/+$/, "");
  }
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitQuote(payload) {
  const { data } = await api.post("/quotes", payload);
  return data;
}
